import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const NAV = [
  { label: "Inicio", href: "#hero" },
  { label: "Sobre mí", href: "#sobre-mi" },
  { label: "Demos", href: "#demos" },
  { label: "Contacto", href: "#contacto" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-[#0a1024]/85 backdrop-blur-md" : "bg-transparent"
      }`}
      data-testid="site-header"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 flex items-center justify-between py-5 md:py-7">
        <a
          href="#hero"
          className="text-[#F25C32] text-sm md:text-base tracking-[0.2em] uppercase font-bold"
          data-testid="brand-handle"
        >
          @santiagovoice
        </a>

        <nav className="hidden md:flex items-center gap-10">
          {NAV.map((n) => (
            <a
              key={n.href}
              href={n.href}
              className="text-sm tracking-[0.18em] uppercase text-[#F5F5F0]/80 hover:text-[#F25C32] transition-colors"
              data-testid={`nav-link-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
            >
              {n.label}
            </a>
          ))}
          <Link
            to="/admin/login"
            className="text-xs tracking-[0.2em] uppercase text-[#9CA3AF] hover:text-[#F25C32] transition-colors"
            data-testid="nav-admin-link"
          >
            Admin
          </Link>
        </nav>

        <button
          className="md:hidden text-[#F5F5F0]"
          onClick={() => setOpen(!open)}
          aria-label="Menu"
          data-testid="mobile-menu-toggle"
        >
          {open ? <X size={28} /> : <Menu size={28} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-[#0a1024]/95 backdrop-blur-md border-t border-white/10 px-6 py-6 space-y-5">
          {NAV.map((n) => (
            <a
              key={n.href}
              href={n.href}
              onClick={() => setOpen(false)}
              className="block text-sm tracking-[0.18em] uppercase text-[#F5F5F0]"
              data-testid={`mobile-nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
            >
              {n.label}
            </a>
          ))}
          <Link
            to="/admin/login"
            onClick={() => setOpen(false)}
            className="block text-xs tracking-[0.2em] uppercase text-[#9CA3AF]"
            data-testid="mobile-nav-admin"
          >
            Admin
          </Link>
        </div>
      )}
    </header>
  );
}
